export default __webpack_public_path__ + "static/dont-overflow-d42ef1a09e47b60dc285551bbfbaa0a6.png";